import { render, staticRenderFns } from "./NovosFornecedoresMesDash.vue?vue&type=template&id=5ff74a8d&"
import script from "./NovosFornecedoresMesDash.vue?vue&type=script&lang=js&"
export * from "./NovosFornecedoresMesDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports